/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */
import { combineReducers } from 'redux';
import { ApplePayWatcherSagas } from './ApplePay';
import googlePayReducer, { googlePayWatcherSagas } from './GooglePay';
import { visaCheckoutWatcherSaga } from './VisaCheckout';
import { chasePayWatcherSaga } from './ChasePay';
import paypalReducer, { paypalWatcherSagas } from './Paypal';
import userPaymentMethodReducer from './UserPaymentMethod/UserPaymentMethod-Reducers';
import creditCardReducer, { creditCardWatcherSagas } from './CreditCard';

const paymentMethodReducer = combineReducers({
    creditCard: creditCardReducer,
    googlepay: googlePayReducer,
    paypal: paypalReducer,
    userPaymentMethod: userPaymentMethodReducer,
});

const paymentMethodWatcherSagas = [
    ...ApplePayWatcherSagas,
    ...chasePayWatcherSaga,
    ...creditCardWatcherSagas,
    ...googlePayWatcherSagas,
    ...paypalWatcherSagas,
    ...visaCheckoutWatcherSaga,
];

export {
    paymentMethodWatcherSagas,
};

export default paymentMethodReducer;
